import { TextInput } from '@mantine/core';
import { defineMessages, useIntl } from 'react-intl';
import { useMemo } from 'react';

import styles from './EventTimePicker.module.scss';

import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';
import { isValid24Hour } from 'utils/timeDateUtils';

const EventTimePicker = () => {
    const intl = useIntl();
    const { values, updateValues } = useEventContext();
    const { timeFrom, timeTo } = values;

    const isFromCorrect = useMemo(() => !timeFrom || isValid24Hour(timeFrom), [timeFrom]);
    const isToCorrect = useMemo(() => !timeTo || isValid24Hour(timeTo), [timeTo]);

    const onFromChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateValues({
            ...values,
            timeFrom: e.target.value,
        });
    };

    const onToChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateValues({
            ...values,
            timeTo: e.target.value,
        });
    };

    return (
        <div className={styles.container}>
            <TextInput
                id="from-event-time-picker"
                type="time"
                value={timeFrom}
                error={!isFromCorrect ? intl.formatMessage(messages.invalidText) : undefined}
                onChange={onFromChange}
                label={intl.formatMessage(messages.from)}
                radius="md"
                size="md"
            />
            <TextInput
                id="to-event-time-picker"
                type="time"
                value={timeTo}
                error={!isToCorrect ? intl.formatMessage(messages.invalidText) : undefined}
                onChange={onToChange}
                label={intl.formatMessage(messages.to)}
                radius="md"
                size="md"
            />
        </div>
    );
};

const messages = defineMessages({
    invalidText: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventPeriod.EventDateTimePicker.EventTimePicker.EventTimePicker.invalidText',
        defaultMessage: 'Niepoprawna godzina',
    },
    from: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventPeriod.EventDateTimePicker.EventTimePicker.EventTimePicker.from',
        defaultMessage: 'Od',
    },
    to: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventPeriod.EventDateTimePicker.EventTimePicker.EventTimePicker.to',
        defaultMessage: 'Do',
    },
});

export default EventTimePicker;
